import { RoleControlledActionConfiguration } from '@/types';

export const roleConfig: RoleControlledActionConfiguration = {
  getAgreements: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: true, hidden: true },
    sales_representative: { restricted: true, hidden: true },
    support_specialist: { restricted: true, hidden: true },
    view_only: { restricted: true, hidden: true },
  },
};
